import { Component, computed, input, output, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { LinkDirective } from '../../../../_shared/directives/link.directive';
import { ICardArticle } from '../../../../_shared/models/card/card-article.model';
import { IChip } from '../../../../_shared/models/chip.model';
import { ImageData } from '../../../../_shared/models/image/image-data.model';
import { EMPTY_LINK, ILink } from '../../../../_shared/models/link.model';
import { MediaImage } from '../../../../_shared/models/media/media-image.model';
import { withConfigFallback } from '../../../../_shared/utils/with-config-fallback';
import { PlayButtonComponent } from '../../../../button/play-button/play-button.component';
import { ChipsComponent } from '../../../../chip/chips.component';
import { HeadingComponent } from '../../../../heading/heading.component';
import { ImageItemComponent } from '../../../../media/media-item/image-item/image-item.component';
import { TextHtmlComponent } from '../../../../text-html/text-html.component';

@Component({
    selector: 'sirius-card-article',
    templateUrl: './card-article.component.html',
    styleUrl: './card-article.component.scss',
    imports: [
        LinkDirective,
        ChipsComponent,
        ImageItemComponent,
        HeadingComponent,
        TextHtmlComponent,
        PlayButtonComponent,
        TranslatePipe,
    ],
    host: {
        // `is-light` keeps the white card readable on dark sections.
        'class': 'sir-card-article sir-text-style-paragraph-m-default is-light',
        '[class.is-video]': 'isVideo()',
        '[class.has-image]': 'hasImage()',
        '(mouseenter)': 'isHighlighted.set(true)',
        '(mouseleave)': 'isHighlighted.set(false)',
        '(focusin)': 'isHighlighted.set(true)',
        '(focusout)': 'isHighlighted.set(false)',
    },
})
export class CardArticleComponent {
    readonly config = input<ICardArticle | undefined>(undefined);
    readonly imageData = input<ImageData | undefined>(undefined);

    readonly title = input('');
    readonly textHtml = input('');
    readonly image = input<MediaImage | undefined>(undefined);
    readonly tags = input<IChip[]>([]);
    readonly attributes = input<IChip[]>([]);
    readonly date = input<string | undefined>(undefined);
    readonly publishedAt = input<string | undefined>(undefined);
    readonly contentType = input('');
    readonly link = input<ILink>(EMPTY_LINK);

    readonly selectEvent = output<void>();

    protected readonly resolvedTitle = withConfigFallback(this.config, 'title', this.title);
    protected readonly resolvedTextHtml = withConfigFallback(this.config, 'textHtml', this.textHtml);
    protected readonly resolvedImage = withConfigFallback(this.config, 'image', this.image);
    protected readonly resolvedTags = withConfigFallback(this.config, 'tags', this.tags);
    protected readonly resolvedAttributes = withConfigFallback(this.config, 'attributes', this.attributes);
    protected readonly resolvedDate = withConfigFallback(this.config, 'date', this.date);
    protected readonly resolvedPublishedAt = withConfigFallback(this.config, 'publishedAt', this.publishedAt);
    protected readonly resolvedContentType = withConfigFallback(this.config, 'contentType', this.contentType);
    protected readonly resolvedLink = withConfigFallback(this.config, 'link', this.link);

    protected readonly hasImage = computed(() => !!this.resolvedImage());
    protected readonly isVideo = computed(() => this.resolvedContentType().toLowerCase() === 'video');

    protected readonly isHighlighted = signal(false);

    protected onClick(): void {
        this.selectEvent.emit();
    }
}
